<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCodeJson } from "@mdi/js";
export default {
  name: "MdiCog",
  data() {
    return {
      svgPath: mdiCodeJson,
    };
  },
};
</script>
